<template>
  <div class="section form-column address-format-from">
    <span class="title" :title="$t('SeaExport.ShippingAndReceivingInformation')">{{ getItemTitle('Customer Information') }}</span>
    <el-form :disabled="readonly" label-width="110px" label-position="right" style="height:100%">
      <!-- 发货人 -->
      <el-form-item :label="getItemTitle('Shipper')" :title="$t('SeaExport.ShipperName')" :class="isDifferent('shipperLine2')">
        <div style="display: flex; margin-bottom: 5px">
          <cargo-company-select
            no="shipperId"
            :method-params="{shipper:true,active:true}"
            :default-value="addressForm.shipperCode||''"
            style="display: inline-block;width:175px;margin-right: 5px"
            :allow-create="true"
            :placeholder="readonly ? '' : 'CODE'"
            @change="data => {shipperChange(data)}"
          />&nbsp;
          <el-button
            no="shipperIdBtn"
            type="primary"
            style="vertical-align: top"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="Name" :title="$t('SeaExport.Name')" :class="lengthOverName(addressForm.shipperLine1) || isDifferent('shipperLine1')">
        <span slot="label">
          <el-tooltip :content="$t('CargoMsg.Cargo_AmsShipperLine1tip')" placement="right-end">
            <i class="el-icon-question" style="cursor: pointer;color: #1F75D5;" />
          </el-tooltip>
          {{ getItemTitle('Name') }}
          <i class="el-icon-search" style="color: blue; font-weight: 1000; cursor:pointer" no="iconSearch3" @click="showSearchBoxAfrAddressDialog('shipper', addressForm.shipperLine1)" />
        </span>
        <el-input v-if="!isEFreight" v-model="addressForm.shipperLine1" no="1" @dblclick.native="showSenderAndReceiverDialog('shipper',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.shipperLine1" no="42" @dblclick.native="eFreightShowSenderAndReceiverDialog('shipperLineName',1)" />
        <!-- 这里第2行作废，原来第2行数据刷到第1行
        <el-input v-model="addressForm.shipperLine2" @dblclick.native="showSenderAndReceiverDialog('shipper',5)" />-->
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '1'" :title="$t('SeaExport.Addr') + '1'" :class="lengthOverAddr(addressForm.shipperLine3) || isDifferent('shipperLine3')">
        <el-input v-if="!isEFreight" v-model="addressForm.shipperLine3" no="2" @dblclick.native="showSenderAndReceiverDialog('shipper',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.shipperLine3" no="43" @dblclick.native="eFreightShowSenderAndReceiverDialog('shipperLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'" :class="lengthOverAddr(addressForm.shipperLine4) || isDifferent('shipperLine4')">
        <el-input v-if="!isEFreight" v-model="addressForm.shipperLine4" no="3" @dblclick.native="showSenderAndReceiverDialog('shipper',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.shipperLine4" no="44" @dblclick.native="eFreightShowSenderAndReceiverDialog('shipperLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.NotBeSent')" class="warning">
        <el-input v-if="!isEFreight" v-model="addressForm.shipperLine5" no="4" @dblclick.native="showSenderAndReceiverDialog('shipper',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.shipperLine5" no="44" @dblclick.native="eFreightShowSenderAndReceiverDialog('shipperLineAddress',4)" />
      </el-form-item>
      <div v-show="!(jsSendHide && isAms)">
        <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
          <div style="display: flex">
            <el-input v-if="!jsSendHide" v-model="addressForm.shipperCountry" :maxlength="2" :class="isDifferent('shipperCountry')" no="5" />
            <cargo-advance-select
              v-else
              :select-type="TYPE_NAMES.basic_data_Country"
              :cache="false"
              filterable
              :default-value="addressForm.shipperCountry"
              :filter-tag-names="['code','chineseName','name']"
              tag-name="code"
              tag-value="code"
              @parentCallBack="p=>{addressForm.shipperCountry = p.value}"
            />
            <span class="center-label" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
            <el-input v-model="addressForm.shipperProvince" :class="isDifferent('shipperProvince')" :maxlength="maxInputLength" no="6" />
          </div>
        </el-form-item>
        <el-form-item :label="getItemTitle('City')" :title="$t('SeaExport.City')">
          <div style="display: flex">
            <el-input v-model="addressForm.shipperCity" :class="isDifferent('shipperCity')" no="7" />
            <span class="center-label" :title="$t('SeaExport.ZIP')">{{ getItemTitle('Zip') }}</span>
            <el-input v-model="addressForm.shipperPostalcode" :class="isDifferent('shipperPostalcode')" :placeholder="readonly?'':$t('SeaExport.ZipForCountry')" no="8" />
          </div>
        </el-form-item>
        <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Tel')" :title="$t('SeaExport.Phone')">
          <div style="display: flex">
            <el-input v-model="addressForm.shipperTel" :placeholder="readonly?'':$t('SeaExport.Optional')" no="9" />
            <span class="center-label" :title="$t('SeaExport.Fax')">{{ getItemTitle('Fax') }}</span>
            <el-input v-model="addressForm.shipperFax" :placeholder="readonly?'':$t('SeaExport.Optional')" no="10" />
          </div>
        </el-form-item>
        <div style="margin-bottom: 10px;" />
      </div>
      <!-- 收货人 -->
      <el-form-item :label="getItemTitle('Consignee')" :title="$t('SeaExport.ConsigneeName')" :class="isDifferent('consigneeLine2')">
        <div style="display: flex; margin-bottom: 5px">
          <cargo-company-select
            no="shipperId"
            :method-params="{shipper:true,active:true}"
            :default-value="addressForm.consigneeCode||''"
            style="display: inline-block;width:175px;margin-right: 5px"
            :allow-create="true"
            :placeholder="readonly ? '' : 'CODE'"
            @change="data => {consigneeChange(data)}"
          />&nbsp;
          <el-button
            no="shipperIdBtn"
            type="primary"
            style="vertical-align: top"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item :label="getItemTitle('Name')" :title="$t('SeaExport.Name')" :class="lengthOverName(addressForm.consigneeLine1) || isDifferent('consigneeLine1')">
        <span slot="label">
          {{ getItemTitle('Name') }}
          <i class="el-icon-search" style="color: blue; font-weight: 1000; cursor:pointer" no="iconSearch1" @click="showSearchBoxAfrAddressDialog('consignee', addressForm.consigneeLine1)" />
        </span>
        <el-input v-if="!isEFreight" v-model="addressForm.consigneeLine1" no="11" @dblclick.native="showSenderAndReceiverDialog('consignee',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.consigneeLine1" no="45" @dblclick.native="eFreightShowSenderAndReceiverDialog('consigneeLineName',1)" />
        <!-- 这里第2行作废，原来第2行数据刷到第1行
        <el-input v-model="addressForm.consigneeLine2" @dblclick.native="showSenderAndReceiverDialog('consignee',5)" /> -->
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '1'" :title="$t('SeaExport.Addr') + '1'" :class="lengthOverAddr(addressForm.consigneeLine3) || isDifferent('consigneeLine3')">
        <el-input v-if="!isEFreight" v-model="addressForm.consigneeLine3" no="12" @dblclick.native="showSenderAndReceiverDialog('consignee',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.consigneeLine3" no="46" @dblclick.native="eFreightShowSenderAndReceiverDialog('consigneeLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'" :class="lengthOverAddr(addressForm.consigneeLine4) || isDifferent('consigneeLine4')">
        <el-input v-if="!isEFreight" v-model="addressForm.consigneeLine4" no="13" @dblclick.native="showSenderAndReceiverDialog('consignee',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.consigneeLine4" no="47" @dblclick.native="eFreightShowSenderAndReceiverDialog('consigneeLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.NotBeSent')" class="warning">
        <el-input v-if="!isEFreight" v-model="addressForm.consigneeLine5" no="14" @dblclick.native="showSenderAndReceiverDialog('consignee',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.consigneeLine5" no="48" @dblclick.native="eFreightShowSenderAndReceiverDialog('consigneeLineAddress',4)" />
      </el-form-item>
      <div v-show="!(jsSendHide && isAms)">
        <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
          <div style="display: flex">
            <el-input v-if="!jsSendHide" v-model="addressForm.consigneeCountry" :maxlength="2" :class="isDifferent('consigneeCountry')" no="15" />
            <cargo-advance-select
              v-else
              :select-type="TYPE_NAMES.basic_data_Country"
              :cache="false"
              filterable
              :default-value="addressForm.consigneeCountry"
              :filter-tag-names="['code','chineseName','name']"
              tag-name="code"
              tag-value="code"
              @parentCallBack="p=>{addressForm.consigneeCountry = p.value}"
            />
            <span class="center-label" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
            <el-input v-model="addressForm.consigneeProvince" :maxlength="maxInputLength" :class="isDifferent('consigneeProvince')" no="16" />
          </div>
        </el-form-item>
        <el-form-item :label="getItemTitle('City')" :title="$t('SeaExport.City')">
          <div style="display: flex">
            <el-input v-model="addressForm.consigneeCity" :class="isDifferent('consigneeCity')" no="17" />
            <span class="center-label" :title="$t('SeaExport.ZIP')">{{ getItemTitle('Zip') }}</span>
            <el-input v-model="addressForm.consigneePostalcode" :class="isDifferent('consigneePostalcode')" :placeholder="readonly?'':$t('SeaExport.ZipForCountry')" no="18" />
          </div>
        </el-form-item>
        <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Tel')" :title="$t('SeaExport.Phone')">
          <div style="display: flex">
            <el-input v-model="addressForm.consigneeTel" :placeholder="readonly?'':$t('SeaExport.Optional')" no="19" />
            <span class="center-label" :title="$t('SeaExport.Fax')">{{ getItemTitle('Fax') }}</span>
            <el-input v-model="addressForm.consigneeFax" :placeholder="readonly?'':$t('SeaExport.Optional')" no="20" />
          </div>
        </el-form-item>
        <div style="margin-bottom: 10px;" />
      </div>
      <!-- 通知人 -->
      <el-form-item :label="getItemTitle('Notify Party')" :title="$t('SeaExport.NotifierName')" :class="isDifferent('notifyLine2')">
        <div style="display: flex; margin-bottom: 5px">
          <cargo-company-select
            no="shipperId"
            :method-params="{shipper:true,active:true}"
            :default-value="addressForm.notifyCode||''"
            style="display: inline-block;width:175px;margin-right: 5px"
            :allow-create="true"
            :placeholder="readonly ? '' : 'CODE'"
            @change="data => {notifyChange(data)}"
          />&nbsp;
          <el-button
            no="shipperIdBtn"
            type="primary"
            style="vertical-align: top"
            @click="billAddressDialog.visible=true"
          >{{ $t('SeaExport.CodeSearching') }}
          </el-button>
        </div>
      </el-form-item>
      <el-form-item label="Name" :title="$t('SeaExport.Name')" :class="lengthOverName(addressForm.notifyLine1) || isDifferent('notifyLine1')">
        <span slot="label">
          {{ getItemTitle('Name') }}
          <i class="el-icon-search" style="color: blue; font-weight: 1000; cursor:pointer" no="iconSearch2" @click="showSearchBoxAfrAddressDialog('notify', addressForm.notifyLine1)" />
        </span>
        <el-input v-if="!isEFreight" v-model="addressForm.notifyLine1" no="21" @dblclick.native="showSenderAndReceiverDialog('notify',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.notifyLine1" no="49" @dblclick.native="eFreightShowSenderAndReceiverDialog('notifyLineName',1)" />
        <!-- 这里第2行作废，原来第2行数据刷到第1行
        <el-input v-model="addressForm.notifyLine2" @dblclick.native="showSenderAndReceiverDialog('notify',5)" /> -->
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '1'" :title="$t('SeaExport.Addr') + '1'" :class="lengthOverAddr(addressForm.notifyLine3) || isDifferent('notifyLine3')">
        <el-input v-if="!isEFreight" v-model="addressForm.notifyLine3" no="22" @dblclick.native="showSenderAndReceiverDialog('notify',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.notifyLine3" no="50" @dblclick.native="eFreightShowSenderAndReceiverDialog('notifyLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="getItemTitle('Address') + '2'" :title="$t('SeaExport.Addr') + '2'" :class="lengthOverAddr(addressForm.notifyLine4) || isDifferent('notifyLine4')">
        <el-input v-if="!isEFreight" v-model="addressForm.notifyLine4" no="23" @dblclick.native="showSenderAndReceiverDialog('notify',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.notifyLine4" no="51" @dblclick.native="eFreightShowSenderAndReceiverDialog('notifyLineAddress',4)" />
      </el-form-item>
      <el-form-item :label="$t('SeaExport.NotBeSent')" class="warning">
        <el-input v-if="!isEFreight" v-model="addressForm.notifyLine5" no="24" @dblclick.native="showSenderAndReceiverDialog('notify',4)" />
        <el-input v-if="isEFreight" v-model="addressForm.notifyLine5" no="52" @dblclick.native="eFreightShowSenderAndReceiverDialog('notifyLineAddress',4)" />
      </el-form-item>
      <div v-show="!(jsSendHide && isAms)">
        <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
          <div style="display: flex">
            <el-input v-if="!jsSendHide" v-model="addressForm.notifyCountry" :maxlength="2" :class="isDifferent('notifyCountry')" no="25" />
            <cargo-advance-select
              v-else
              :select-type="TYPE_NAMES.basic_data_Country"
              :cache="false"
              filterable
              :default-value="addressForm.notifyCountry"
              :filter-tag-names="['code','chineseName','name']"
              tag-name="code"
              tag-value="code"
              @parentCallBack="p=>{addressForm.notifyCountry = p.value}"
            />
            <span class="center-label" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
            <el-input v-model="addressForm.notifyProvince" maxlength="2" :class="isDifferent('notifyProvince')" no="26" />
          </div>
        </el-form-item>
        <el-form-item :label="getItemTitle('City')" :title="$t('SeaExport.City')">
          <div style="display: flex">
            <el-input v-model="addressForm.notifyCity" :class="isDifferent('notifyCity')" no="27" />
            <span class="center-label" :title="$t('SeaExport.ZIP')">{{ getItemTitle('Zip') }}</span>
            <el-input v-model="addressForm.notifyPostalcode" :class="isDifferent('notifyPostalcode')" :placeholder="readonly?'':$t('SeaExport.ZipForCountry')" no="28" />
          </div>
        </el-form-item>
        <el-form-item v-show="!(jsSendHide && isAci)" :label="getItemTitle('Tel')" :title="$t('SeaExport.Phone')">
          <div style="display: flex">
            <el-input v-model="addressForm.notifyTel" :placeholder="readonly?'':$t('SeaExport.Optional')" no="29" />
            <span class="center-label" :title="$t('SeaExport.Fax')">{{ getItemTitle('Fax') }}</span>
            <el-input v-model="addressForm.notifyFax" :placeholder="readonly?'':$t('SeaExport.Optional')" no="30" />
          </div>
        </el-form-item>
      </div>
      <!-- 第二通知人 -->
      <div v-if="showSecondNotifyParty">
        <el-form-item :label="getItemTitle('Second Notify Party')" :title="$t('SeaExport.SecondNotifierName')">
          <el-input v-model="addressForm.alsonotifyLine1" :placeholder="readonly ? '' : 'CODE'" no="31" @dblclick.native="showSenderAndReceiverDialog('alsonotify',5)" />
          <el-input v-model="addressForm.alsonotifyLine2" no="32" @dblclick.native="showSenderAndReceiverDialog('alsonotify',5)" />
        </el-form-item>
        <el-form-item :label="getItemTitle('Address')" :title="$t('SeaExport.Address')">
          <el-input v-model="addressForm.alsonotifyLine3" no="33" @dblclick.native="showSenderAndReceiverDialog('alsonotify',5)" />
          <el-input v-model="addressForm.alsonotifyLine4" no="34" @dblclick.native="showSenderAndReceiverDialog('alsonotify',5)" />
          <el-input v-model="addressForm.alsonotifyLine5" no="35" @dblclick.native="showSenderAndReceiverDialog('alsonotify',5)" />
        </el-form-item>
        <el-form-item :label="getItemTitle('Country')" :title="$t('SeaExport.Country')">
          <div style="display: flex">
            <el-input v-model="addressForm.alsonotifyCountry" :maxlength="2" no="36" />
            <span class="center-label" :title="$t('SeaExport.Province')">{{ getItemTitle('State') }}</span>
            <el-input v-model="addressForm.alsonotifyProvince" :maxlength="maxInputLength" no="37" />
          </div>
        </el-form-item>
        <el-form-item :label="getItemTitle('City')" :title="$t('SeaExport.City')">
          <div style="display: flex">
            <el-input v-model="addressForm.alsonotifyCity" no="38" />
            <span class="center-label" :title="$t('SeaExport.ZIP')">{{ getItemTitle('Zip') }}</span>
            <el-input v-model="addressForm.alsonotifyPostalcode" no="39" />
          </div>
        </el-form-item>
        <el-form-item :label="getItemTitle('Tel')" :title="$t('SeaExport.Phone')">
          <div style="display: flex">
            <el-input v-model="addressForm.alsonotifyTel" :placeholder="readonly?'':$t('SeaExport.Optional')" no="40" />
            <span class="center-label" :title="$t('SeaExport.Fax')">{{ getItemTitle('Fax') }}</span>
            <el-input v-model="addressForm.alsonotifyFax" :placeholder="readonly?'':$t('SeaExport.Optional')" no="41" />
          </div>
        </el-form-item>
      </div>
    </el-form>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog
      :visible.sync="billAddressDialog.visible"
      :job="job"
      @callback="codeSearchCallback"
    />
    <!-- 放大镜单号抄录弹窗 -->
    <search-box-afr-address-dialog
      :visible.sync="searchBoxAfrAddressDialog.visible"
      :params="searchBoxAfrAddressDialog.params"
      :customer-type="customerType"
      @selected="p=>{selectionItemHandlerByType(p)}"
    />
  </div>
</template>

<script>

import { Company } from '@/class/model/mdm/Company'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import BillAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import { cache, cacheName } from '@/utils/cacheManager'
import SearchBoxAfrAddressDialog from '@/components/Cargo/Job/searchBoxAfrAddressDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'

export default {
  name: 'AddressFormatForm',
  components: { BillAddressDialog, CargoCompanySelect, SearchBoxAfrAddressDialog, CargoAdvanceSelect },
  props: {
    addressForm: { type: Object, default: () => {} },
    localData: { type: Object, default: () => {} },
    job: { type: Object, default: () => {} },
    readonly: { type: Boolean, default: true },
    showSecondNotifyParty: { type: Boolean, default: false },
    tabName: { type: String, required: true },
    isJs: { type: Boolean, default: false },
    jsSendHide: { type: Boolean, default: false }
  },
  data() {
    return {
      TYPE_NAMES,
      billAddressDialog: {
        visible: false
      },
      maxInputLength: null, // 初始化为null，表示无限制
      isTradetech: false,
      isEFreight: false,
      searchBoxAfrAddressDialog: {
        visible: false,
        params: {}
      },
      isChineseLanguage: false,
      customerType: '' // 收发通客户类型 shipper、consignee、notify
    }
  },
  computed: {
    isAms() {
      return this.tabName === 'ams'
    },
    isAci() {
      return this.tabName === 'aci'
    }
  },
  mounted() {
    cache.load(cacheName.CONFIG)
    this.config = cache.config
    this.isTradetech = this.config.get('AMSInterfaceName') === 'tradetech'
    this.isEFreight = this.config.get('AMSInterfaceName') === 'eFreight'
    if (this.isTradetech) {
      this.maxInputLength = 2
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const cacheConfig = cache.config
    this.isChineseLanguage = Number(cacheConfig.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
  },
  methods: {
    showSenderAndReceiverDialog(type, count) {
      this.$emit('showSenderAndReceiverDialog', type, count, type !== 'alsonotify')
    },
    eFreightShowSenderAndReceiverDialog(type, count) {
      this.$emit('showSenderAndReceiverDialog', type, count, type !== 'alsonotify')
    },
    isDifferent(field) {
      return this.localData.importDifferentField && this.localData.importDifferentField.afrAddress &&
      this.localData.importDifferentField.afrAddress.hasOwnProperty(field) ? 'warning' : ''
    },
    // 验证名称变红
    lengthOverName(value) {
      if (!value) return ''
      return value.length > (this.tabName !== 'eManifest' && !this.isEFreight ? 35 : 70) ? 'warning' : ''
    },
    // 验证地址变红
    lengthOverAddr(value) {
      if (!value) return ''
      return value.length > (this.tabName !== 'eManifest' && !this.isEFreight ? 35 : 50) ? 'warning' : ''
    },
    /**
     * 发货人选择
     */
    async shipperChange(data) {
      const form = this.addressForm
      form.shipperId = data.value
      if (form.shipperId) {
        // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.shipperLine1 = manifestAddress.addressLine1
          // form.shipperLine2 = manifestAddress.addressLine2
          form.shipperLine3 = manifestAddress.addressLine2
          form.shipperLine4 = manifestAddress.addressLine3
          //
          let shipperLine5 = manifestAddress.addressLine4 || ''
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine5) shipperLine5 += manifestAddress.addressLine5
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine6) shipperLine5 += manifestAddress.addressLine6
          if (shipperLine5) shipperLine5 += '\n'
          if (manifestAddress.addressLine7) shipperLine5 += manifestAddress.addressLine7
          form.shipperLine5 = shipperLine5
        } else {
          form.shipperLine1 = ''
          form.shipperLine2 = ''
          form.shipperLine3 = ''
          form.shipperLine4 = ''
          form.shipperLine5 = ''
          form.shipperLine6 = ''
          form.shipperLine7 = ''
        }
      }
    },
    /**
     * 收货人选择
     */
    async consigneeChange(data) {
      const form = this.addressForm
      form.consigneeId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.consigneeId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.consigneeLine1 = manifestAddress.addressLine1
          // form.consigneeLine2 = manifestAddress.addressLine2
          form.consigneeLine3 = manifestAddress.addressLine2
          form.consigneeLine4 = manifestAddress.addressLine3
          //
          let consigneeLine5 = manifestAddress.addressLine4 || ''
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine5) consigneeLine5 += manifestAddress.addressLine5
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine6) consigneeLine5 += manifestAddress.addressLine6
          if (consigneeLine5) consigneeLine5 += '\n'
          if (manifestAddress.addressLine7) consigneeLine5 += manifestAddress.addressLine7
          form.consigneeLine5 = consigneeLine5
        } else {
          form.consigneeLine1 = ''
          form.consigneeLine2 = ''
          form.consigneeLine3 = ''
          form.consigneeLine4 = ''
          form.consigneeLine5 = ''
          form.consigneeLine6 = ''
          form.consigneeLine7 = ''
        }
      }
    },
    /**
     * 通知人选择
     */
    async notifyChange(data) {
      const form = this.addressForm
      form.notifyId = data.value
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      if (form.notifyId) {
        const company = new Company(data)
        const manifestAddress = await company.getManifestAddress()
        if (manifestAddress) {
          form.notifyLine1 = manifestAddress.addressLine1
          // form.notifyLine2 = manifestAddress.addressLine2
          form.notifyLine3 = manifestAddress.addressLine2
          form.notifyLine4 = manifestAddress.addressLine3
          //
          let notifyLine5 = manifestAddress.addressLine4 || ''
          if (notifyLine5) notifyLine5 += '\n'
          if (manifestAddress.addressLine5) notifyLine5 += manifestAddress.addressLine5
          if (notifyLine5) notifyLine5 += '\n'
          if (manifestAddress.addressLine6) notifyLine5 += manifestAddress.addressLine6
          if (notifyLine5) notifyLine5 += '\n'
          if (manifestAddress.addressLine7) notifyLine5 += manifestAddress.addressLine7
          form.notifyLine5 = notifyLine5
        } else {
          form.notifyLine1 = ''
          form.notifyLine2 = ''
          form.notifyLine3 = ''
          form.notifyLine4 = ''
          form.notifyLine5 = ''
          form.notifyLine6 = ''
          form.notifyLine7 = ''
        }
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.addressForm['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.addressForm['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.addressForm['notifyCode'] = data.notifyCode || ''
      }
    },
    splitShipperLine(val) {
      this.splitSenderAndReceiverLine('shipper', 5, val)
    },
    splitSenderAndReceiverLine(type, count, val) {
      const addressForm = this.addressForm
      let fromIndex = 0
      let i = 1
      let no = 1
      for (; i < count; ++i) {
        no = (i !== 1) ? (i + 1) : i
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          addressForm[`${type}Line${no}`] = ''
          continue
        }
        addressForm[`${type}Line${no}`] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      addressForm[`${type}Line${no}`] = val.substring(fromIndex)
    },
    splitConsigneeLine(val) {
      this.splitSenderAndReceiverLine('consignee', 5, val)
    },
    splitNotifyLine(val) {
      this.splitSenderAndReceiverLine('notify', 5, val)
    },
    showSearchBoxAfrAddressDialog(customerType, searchText) {
      if (this.readonly) {
        return
      }
      this.searchBoxAfrAddressDialog.params = {
        docType: 'AMS',
        selectType: 'single',
        job: this.job
      }
      if (customerType === 'shipper') {
        this.searchBoxAfrAddressDialog.params.shipper = searchText
      } else if (customerType === 'consignee') {
        this.searchBoxAfrAddressDialog.params.consignee = searchText
      } else if (customerType === 'notify') {
        this.searchBoxAfrAddressDialog.params.notify = searchText
      }
      this.customerType = customerType
      this.searchBoxAfrAddressDialog.visible = true
    },
    selectionItemHandlerByType(row) {
      this.$emit('selectionItemHandlerByType', row)
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    }
  }
}
</script>

<style lang='scss'>
.address-format-from{
  .center-label{
    margin-left: 5px;
    margin-right: 5px;
    width: 110px;
  }
}
</style>
